module.exports = __webpack_public_path__ + "img/icon-65.35937cbb.svg";